import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import de from "./locales/de.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";

// SUPPORTED_LANGUAGES is the PUBLIC switcher list for V1. French and
// Spanish locale files remain in the bundle below so we can roll them out
// later without code changes, but they are intentionally NOT exposed in
// the language switcher until translation coverage is ready. Any user
// that already has fr/es persisted in localStorage is gracefully mapped
// to English by the language detector below.
export const SUPPORTED_LANGUAGES = [
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
];

// Internal full list — used for resource registration only, not for the
// public language switcher. Keep this in sync with the locale files.
const ALL_LOADED_LOCALES = ["en", "de", "fr", "es"];
// Locales that are publicly selectable in V1.
const PUBLIC_LOCALES = ["en", "de"];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      de: { translation: de },
      fr: { translation: fr },
      es: { translation: es },
    },
    fallbackLng: "en",
    // supportedLngs constrains what the detector can resolve to. Keeping
    // only public locales here means a stored "fr"/"es" preference falls
    // back to "en" automatically without losing the underlying resources.
    supportedLngs: PUBLIC_LOCALES,
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "doing_good_lang",
    },
  });

// If a previous visit stored a non-public locale (fr/es) in localStorage,
// switch them gracefully to English so the public switcher stays in sync.
const _saved = typeof localStorage !== "undefined" ? localStorage.getItem("doing_good_lang") : null;
if (_saved && !PUBLIC_LOCALES.includes(String(_saved).split("-")[0])) {
  i18n.changeLanguage("en");
}

// Suppress noisy lint warning for intentionally unused constant.
export { ALL_LOADED_LOCALES };

// Keep <html lang> in sync with active i18n language for a11y and SEO.
// Strip region (e.g. "de-DE" -> "de") so it matches our supported locales.
const syncHtmlLang = (lng) => {
  if (typeof document === "undefined" || !lng) return;
  const base = String(lng).split("-")[0];
  if (document.documentElement.getAttribute("lang") !== base) {
    document.documentElement.setAttribute("lang", base);
  }
};
syncHtmlLang(i18n.language);
i18n.on("languageChanged", syncHtmlLang);

export default i18n;
